import { inlineMediaQueryMixin } from "@zillow/constellation";
const videoMixin = (props) => {
  const styles = [];
  if ("ratio" in props) {
    styles.push(inlineMediaQueryMixin("ratio", (mediaProps) => {
      return `max-width: 100%; height: auto; aspect-ratio: ${mediaProps.ratio};`;
    })(props));
  }
  return styles;
};
export {
  videoMixin
};
